import React from 'react'

import Map from '../Map/ExperimentalMap'

export default function Page() {
  return <Map />
}
